import { PARAM_ENTITY_ID, PARAM_OFFER_ID } from './route.model';
import { StaticPathRouter } from './typed-router.model';

export const CONTACT_LIST_URL: StaticPathRouter[] = ['offer', PARAM_OFFER_ID, 'contacts'];
export const CONTACT_DETAILS_URL: StaticPathRouter[] = [...CONTACT_LIST_URL, PARAM_ENTITY_ID, 'details'];

export const PETIT_JOURNAL_LIST_URL: StaticPathRouter[] = ['offer', PARAM_OFFER_ID, 'petits-journaux'];

export const PLANNING_LIST_URL: StaticPathRouter[] = ['offer', PARAM_OFFER_ID, 'plannings'];

export const PROFESSIONAL_LIST_URL: StaticPathRouter[] = ['offer', PARAM_OFFER_ID, 'professionals'];
export const PROFESSIONAL_DETAILS_URL: StaticPathRouter[] = [...PROFESSIONAL_LIST_URL, PARAM_ENTITY_ID, 'details'];
export const TEAM_LIST_URL: StaticPathRouter[] = [...PROFESSIONAL_LIST_URL, 'teams'];

export const PUBLICATION_LIST_URL: StaticPathRouter[] = ['offer', PARAM_OFFER_ID, 'publications'];
export const PUBLICATION_DETAILS_URL: StaticPathRouter[] = [...PUBLICATION_LIST_URL, PARAM_ENTITY_ID, 'details'];

export const RESIDENT_LIST_URL: StaticPathRouter[] = ['offer', PARAM_OFFER_ID, 'residents'];
export const RESIDENT_DETAILS_URL: StaticPathRouter[] = [...RESIDENT_LIST_URL, PARAM_ENTITY_ID, 'details'];

export const ROOM_LIST_URL: StaticPathRouter[] = ['offer', PARAM_OFFER_ID, 'rooms'];
export const ROOM_DETAILS_URL: StaticPathRouter[] = [...ROOM_LIST_URL, PARAM_ENTITY_ID, 'details'];

export const MATERIAL_SERVICES_URL: StaticPathRouter[] = ['offer', PARAM_OFFER_ID, 'services'];

export const MATERIAL_DETAILS_URL: StaticPathRouter[] = [
  'offer',
  PARAM_OFFER_ID,
  'materials',
  PARAM_ENTITY_ID,
  'details',
];

export const MATERIAL_MONITORING_URL: StaticPathRouter[] = [...MATERIAL_SERVICES_URL, 'monitoring'];

export const ETS_PROFILE_URL: StaticPathRouter[] = ['offer', PARAM_OFFER_ID, 'ets'];

export const WEB_RADIO_LIST_URL: StaticPathRouter[] = ['offer', PARAM_OFFER_ID, 'web-radios'];

export const HQ_PUBLICATION_LIST_URL: StaticPathRouter[] = ['hq-publications'];
export const HQ_PUBLICATION_DETAILS_URL: StaticPathRouter[] = [...HQ_PUBLICATION_LIST_URL, PARAM_ENTITY_ID, 'details'];

export const HQ_PROFESSIONAL_LIST_URL: StaticPathRouter[] = ['hq-professionals'];
export const HQ_PROFESSIONAL_DETAILS_URL: StaticPathRouter[] = [
  ...HQ_PROFESSIONAL_LIST_URL,
  PARAM_ENTITY_ID,
  'details',
];

export const MESSAGING_LIST_URL: StaticPathRouter[] = ['offer', PARAM_OFFER_ID, 'messaging'];

export const OFFER_SERVICES_URL: StaticPathRouter[] = ['offer', PARAM_OFFER_ID, 'services'];

export const INTERNAL_CHANNEL_DETAILS_URL: StaticPathRouter[] = [
  'offer',
  PARAM_OFFER_ID,
  'services',
  'channels',
  PARAM_ENTITY_ID,
  'details',
];

export const TV_CHANNEL_LIST_URL: StaticPathRouter[] = ['offer', PARAM_OFFER_ID, 'tv-channels'];
export const TV_PACKAGE_LIST_URL: StaticPathRouter[] = [...TV_CHANNEL_LIST_URL, 'tv-packages'];

export const SERVICE_NOTE_LIST_URL: StaticPathRouter[] = ['offer', PARAM_OFFER_ID, 'service-notes'];

export const SOFTWARE_ADMIN_LIST_URL: StaticPathRouter[] = ['admin', 'software'];

export const CACHE_FILE_LIST_URL: StaticPathRouter[] = ['admin', 'cache-file'];

export const CACHE_LIST_URL: StaticPathRouter[] = ['admin', 'cache-list'];

export const FIRMWARE_ADMIN_LIST_URL: StaticPathRouter[] = ['admin', 'firmware'];

export const DICTATION_ADMIN_LIST_URL: StaticPathRouter[] = ['admin', 'dictation'];

export const PROVERB_ADMIN_LIST_URL: StaticPathRouter[] = ['admin', 'proverb'];

export const HEADQUARTER_ADMIN_LIST_URL: StaticPathRouter[] = ['admin', 'headquarters'];

export const ADMIN_USERS_LIST_URL: StaticPathRouter[] = ['admin', 'users'];

export const CONFIGURATION_URL: StaticPathRouter[] = ['admin', 'configuration'];

export const OFFER_CONFIGURATION: StaticPathRouter[] = ['offer', PARAM_OFFER_ID, 'offer-configuration'];

export const QUIZ_ADMIN_LIST_URL: StaticPathRouter[] = ['admin', 'quiz'];

export const QUESTION_LIST_URL: StaticPathRouter[] = [...QUIZ_ADMIN_LIST_URL, PARAM_ENTITY_ID, 'details'];
export const POST_PICTURE_LIST_URL: StaticPathRouter[] = ['admin', 'post-pictures'];

export const HQ_ADMIN_URL: StaticPathRouter[] = ['hq-administration'];

export const CUSTOM_LAYOUT_LIST: StaticPathRouter[] = ['custom-layout'];
